import React from 'react';
import {CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';
import FeatherIcon from 'feather-icons-react';
import {CHART_COLORS} from '../../utils/chartColors';

const formatMonthTick = (month) => {
  if (!month) return '';
  const [year, m] = month.split('-');
  const date = new Date(Number(year), Number(m) - 1, 1);
  return date.toLocaleDateString('en-US', {month: 'short', year: '2-digit'});
};

const UserGrowthLineChart = ({data}) => {
  if (!data || data.length === 0) {
    return (
      <div className="empty-results mt-5">
        <FeatherIcon icon="info"/>
        <div className="empty-results-text">No growth data available</div>
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={320}>
      <LineChart data={data} margin={{top: 8, right: 16, left: 0, bottom: 8}}>
        <CartesianGrid strokeDasharray="3 3" vertical={false}/>
        <XAxis dataKey="month" tickFormatter={formatMonthTick} tick={{fontSize: 11}}/>
        <YAxis allowDecimals={false} tick={{fontSize: 11}}/>
        <Tooltip labelFormatter={formatMonthTick} contentStyle={{fontSize: 12}} labelStyle={{fontWeight: 600}}/>
        <Line
          type="monotone"
          dataKey="newUsers"
          name="New Users"
          stroke={CHART_COLORS.primary}
          strokeWidth={2}
          dot={{r: 3}}
          activeDot={{r: 5}}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default UserGrowthLineChart;
